import React from 'react';
export const DropdownContext = React.createContext({});
export const TabPaneContext = React.createContext({});
